import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import _ from 'lodash';

import Pagination from 'components/Libs/Pagination';
import TextField from 'material-ui/TextField';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';

class AnnotationList extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            rowsPerPage: [10, 20, 30],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            annotations: props.annotations,
            searchText: '',
        };
        
        this.handleUpdateRow = this.handleUpdateRow.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.filterAnnotations = this.filterAnnotations.bind(this);
    }

    filterAnnotations(text = this.state.searchText, annotations = this.props.annotations) {
        text = text.toLowerCase();

        const filteredAnnotations = annotations.filter((annotation) => {
            if (_.has(annotation, 'features.rule')
                && annotation.features.rule.toLowerCase().includes(text)) {
                return true;
            }

            if (_.has(annotation, 'features.majorType')
                && annotation.features.majorType.toLowerCase().includes(text)) {
                return true;
            }

            if (_.has(annotation, 'features.string')
                && annotation.features.string.toLowerCase().includes(text)) {
                return true;
            }

            if (_.has(annotation, 'type')
                && annotation.type.toLowerCase().includes(text)) {
                return true;
            }

            if (annotation.id) {
                const id = annotation.id + '';
                if (id.includes(text)) {
                    return true;
                }
            }

            return false;
        });

        return {
            searchText: text,
            annotations: filteredAnnotations,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { annotations } = this.filterAnnotations(this.state.searchText, nextProps.annotations);

        this.setState({
            page: 1,
            annotations,
            total: nextProps.annotations.length,
        }, () => {
            this.handleUpdateRow(this.state);
        });
    }
    
    handleSearch(e, value) {
        const { annotations, searchText } = this.filterAnnotations(value);

        this.setState({
            page: 1,
            annotations,
            searchText,
        }, () => {
            this.handleUpdateRow(this.state);
        });
    }
    
    changeRowsByPagination(state) {
        const elementsOnPage = state.numberOfRows;
        const offset = state.page - 1;
        const from = offset * elementsOnPage;
        const to = (offset * elementsOnPage) + elementsOnPage;
        
        return this.state.annotations.slice(from, to);
    }
    
    handleUpdateRow(newState) {
        const rows = this.changeRowsByPagination(newState);
        const state = newState;
        state.rows = rows;
        
        this.setState(state);
    }
    
    render() {
        const { annotations, rowsPerPage, page, numberOfRows, rows, searchText } = this.state;

        return (
            <div className='annotations-list-b'>
                <div className='navigation'>

                    <div className='navigation-search'>
                        <TextField
                            hintText='Search'
                            hintStyle={{ fontSize: 12 }}
                            style={{ fontSize: 12 }}
                            onChange={this.handleSearch}
                            value={searchText || ''}
                        />
                    </div>

                    <div className='navigation-arrows'>
                        <Pagination
                            total={annotations.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            numberOfRows={numberOfRows}
                            updateRows={this.handleUpdateRow}
                        />
                    </div>
                </div>

                <div className='annotations-table'>
                    <Table selectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow style={{ height: '28px' }}>
                                <TableHeaderColumn style={{ padding: '0 24px', height: '28px' }}>Value</TableHeaderColumn>
                                <TableHeaderColumn style={{ padding: '0 24px', height: '28px' }}>Rule</TableHeaderColumn>
                                <TableHeaderColumn style={{ padding: '0 24px', height: '28px' }}>Type</TableHeaderColumn>
                                <TableHeaderColumn style={{ padding: '0 24px', height: '28px' }}>MajorType</TableHeaderColumn>
                                <TableHeaderColumn style={{ padding: '0 24px', height: '28px' }}>id</TableHeaderColumn>
                            </TableRow>
                        </TableHeader>

                        <TableBody displayRowCheckbox={false}>
                            {
                                rows.map((annotation, i) => {
                                    return (<TableRow style={{ height: '28px' }} key={i}>
                                        <TableRowColumn style={{ padding: '0 24px', height: '28px' }}>{annotation.features.string}</TableRowColumn>
                                        <TableRowColumn style={{ padding: '0 24px', height: '28px' }}>{annotation.features.rule}</TableRowColumn>
                                        <TableRowColumn style={{ padding: '0 24px', height: '28px' }}>{annotation.type}</TableRowColumn>
                                        <TableRowColumn style={{ padding: '0 24px', height: '28px' }}>{annotation.features.majorType}</TableRowColumn>
                                        <TableRowColumn style={{ padding: '0 24px', height: '28px' }}>{annotation.id}</TableRowColumn>
                                    </TableRow>);
                                })
                            }
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    }
}

AnnotationList.propTypes = {
    annotations: PropTypes.array,
};

AnnotationList.defaultProps = {
    annotations: [],
};

export default connect(
    ({ train }) => {
        return {
            annotations: train.annotations,
        };
    },
    dispatch => bindActionCreators({

    }, dispatch),
)(AnnotationList);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Train/List/Annotation.jsx